import { useTranslation } from "react-i18next"
import { useRecoilState } from "recoil"
import { Button } from "../App.styles"
import { Typography } from "@material-ui/core"
import EmptyPage from "../common/EmptyPage"
import { ReactComponent as SearchEmpty } from "../images/search-empty.svg"
import { termState } from "./Organize.state"

const OrganizeSearchEmpty = () => {
    const { t } = useTranslation()
    const [term, setTerm] = useRecoilState(termState)

    const onClearSearch = () => {
        setTerm("")
    }

    return (
        <EmptyPage>
            <SearchEmpty />
            <div>
                <Typography className="text-center mb-4">
                    {t('No challenges found for search term:')} <strong>"{term}"</strong>
                </Typography>
                <Button 
                    data-testid="challenge__clear-search" 
                    size="lg" 
                    className="btn--flat btn--flat-sm d-block w-100" 
                    color="primary" 
                    onClick={onClearSearch}
                >
                    {t('Clear Search')}
                </Button>
            </div>
        </EmptyPage>
    )
}

export default OrganizeSearchEmpty 